import { render, staticRenderFns } from "./gamedetail.vue?vue&type=template&id=628c0ae4&scoped=true&"
import script from "./gamedetail.vue?vue&type=script&lang=js&"
export * from "./gamedetail.vue?vue&type=script&lang=js&"
import style0 from "./gamedetail.vue?vue&type=style&index=0&id=628c0ae4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628c0ae4",
  null
  
)

export default component.exports